import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ButtonModule} from 'primeng/button';
import {TableModule} from 'primeng/table';
import {environment} from '../../../environments/environment';
import {Popover} from 'primeng/popover';


@Component({
  selector: 'app-accessibility-details',
  imports: [CommonModule, ButtonModule, TableModule, Popover],
  standalone: true,
  templateUrl: './accessibility-details.component.html',
  styleUrl: './accessibility-details.component.css'
})
export class AccessibilityDetailsComponent {

  @Input() accessibilityData: any = {};
  @Input() testId: any = {};

  trackByIndex(index: number, item: any): number {
    return index;
  }

  getReportUrlFromPath(path: string): string {
    if (!path) {
      return '';
    }
    const pathParts = path.split('/').pop();
    return `${environment.apiUrl}/reports/accessibility/${this.testId}/${pathParts}`;
  }

  getIssuesCountText(issuesCount: number): string {
    if (!issuesCount) {
      return 'No issues';
    }

    if (issuesCount === 1) {
      return '1 Issue';
    }

    return `${issuesCount} Issues`;

  }

  getTotalIssuesCount(): string {
    let pagesWithIssuesCount = 0;
    const uniqueRecommendations = new Set();

    if (!this.accessibilityData?.AxeContentCheck) {
      return 'No results available';
    }

    const validChecks = this.accessibilityData.AxeContentCheck.filter(
      (page: any) => page.status !== 'error'
    );

    validChecks.forEach((page: any) => {
      if (page.issues) {
        pagesWithIssuesCount++;
        page.recommendations?.forEach((recommendation: any) => {
          uniqueRecommendations.add(recommendation);
        });
      }
    });

    return validChecks.length ?
      `Found ${uniqueRecommendations.size} unique issues on ${pagesWithIssuesCount} pages` :
      'No results available';
  }

  hasValidResults(): boolean {
    return this.accessibilityData?.AxeContentCheck?.some((check: any) =>
      check.status !== 'error' && (check.recommendations || check.url)
    );
  }

  getPagesWithNoIssues(): any[] {
    if (!this.accessibilityData?.AxeContentCheck) {
      return [];
    }
    return this.accessibilityData.AxeContentCheck.filter((page: any) => !page.recommendations && (!page.status || page.status !== 'error'));
  }

  getPagesWithErrors(): any[] {
    if (!this.accessibilityData?.AxeContentCheck) {
      return []
    }

    return this.accessibilityData.AxeContentCheck.filter((page: any) => page.status === 'error');
  }
}
